"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var dropdown_styles_1 = require("./dropdown.styles");
var core_components_1 = require("@securityproducts/core-components");
var optionHeight = 33;
function Dropdown(props) {
    var selectNode = React.useRef(null);
    var _a = React.useState(false), showOptions = _a[0], setShowOptions = _a[1];
    function toggleOptions() {
        setShowOptions(!showOptions);
    }
    function callAction(callback, id) {
        core_components_1.AnalyticsService.recordEvent(id);
        callback();
        setShowOptions(false);
    }
    function handleClick(e) {
        if (selectNode.current && selectNode.current.contains(e.target)) {
            return;
        }
        else {
            setShowOptions(false);
        }
    }
    React.useEffect(function () {
        document.addEventListener("mousedown", handleClick, false);
        return function () {
            document.removeEventListener("mousedown", handleClick, false);
        };
    }, []);
    var optionsClass = props.showOnLeft ? dropdown_styles_1.optionsLeft : dropdown_styles_1.options;
    var top = optionHeight;
    return (React.createElement("div", { onClick: toggleOptions, className: dropdown_styles_1.container, ref: selectNode, id: props.id },
        props.children,
        showOptions && (React.createElement("div", { className: optionsClass, style: { top: top }, id: props.id + "-options" }, props.options.map(function (option, index) { return (React.createElement("div", { key: index, onClick: function () { return callAction(option.action, option.id); }, className: dropdown_styles_1.getOptionsDiv(optionHeight), id: option.id ? option.id : "" + option.text.replace(/\s/g, ""), "data-qa": "dropdown-option" }, option.text)); })))));
}
exports.Dropdown = Dropdown;
